export default __webpack_public_path__ + "static/media/Instrument.f1689c5b.jpg";